const tools = [
  {
    id: 'esha',
    value: 'esha',
    facet: 'AnalyzeMyDiet Tracker',
    labels: {
      toolLabel: 'AnalyzeMyDiet Tracker'
    },
    toolIcon: 'document',
    isIntegrationHubLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'altp',
    value: 'activelearning',
    facet: 'In-Class Activity',
    labels: {
      toolLabel: 'In-Class Activity Guide',
      searchResultLabel: 'In-Class Activity'
    },
    toolIcon: 'in_class',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'reading',
    value: 'reading',
    facet: 'Reading',
    labels: {
      toolLabel: 'Reading',
      searchResultLabel: 'Reading'
    },
    toolIcon: 'book',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: true,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'readandpractice',
    value: 'lcrp',
    facet: 'Read and Practice',
    labels: {
      toolLabel: 'Read and Practice',
      searchResultLabel: 'Read and Practice'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'lcrp',
    value: 'lcrp',
    facet: 'Read and Practice',
    labels: {
      toolLabel: 'Read and Practice',
      searchResultLabel: 'Read and Practice'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: true,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'lc',
    value: 'lc',
    facet: 'Read and Practice',
    labels: {
      toolLabel: 'Read and Practice',
      searchResultLabel: 'Read and Practice'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: true,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'learning_curve_read_and_practice',
    value: 'learning_curve_read_and_practice',
    facet: 'Read and Practice',
    labels: {
      toolLabel: 'Read and Practice',
      searchResultLabel: 'Read and Practice'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'learningcurve',
    value: 'learningcurve',
    facet: 'LearningCurve',
    labels: {
      toolLabel: 'Adaptive Quiz',
      searchResultLabel: 'Learning Curve'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: true,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'pathfinder',
    value: 'pathfinder',
    facet: 'Diagnostic',
    labels: {
      toolLabel: 'Diagnostic',
      searchResultLabel: 'Diagnostic'
    },
    toolIcon: 'adaptive_quiz',
    subtypes: [
      {
        id: 'PreTest',
        labels: {
          toolLabel: 'Diagnostic - Practice Test'
        }
      },
      {
        id: 'PostTest',
        labels: {
          toolLabel: 'Diagnostic - Final Test'
        }
      },
      {
        id: 'Milestone',
        labels: {
          toolLabel: 'Diagnostic - Study Plan'
        }
      }
    ],
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'pathfinder2',
    value: 'pathfinder-2',
    facet: 'Diagnostic',
    labels: {
      toolLabel: 'Diagnostic',
      searchResultLabel: 'Diagnostic'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    subtypes: [
      {
        id: 'PreTest',
        labels: {
          toolLabel: 'Diagnostic - Practice Test'
        }
      },
      {
        id: 'PostTest',
        labels: {
          toolLabel: 'Diagnostic - Final Test'
        }
      },
      {
        id: 'Milestone',
        labels: {
          toolLabel: 'Diagnostic - Study Plan'
        }
      }
    ],
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'assessment',
    value: 'assessment',
    facet: 'Assessment',
    labels: {
      toolLabel: 'Assessment',
      searchResultLabel: 'Assessment'
    },
    subtypes: [
      {
        id: 'short-form-writing',
        labels: {
          toolLabel: 'Short-Form Writing'
        }
      },
      {
        id: 'cca',
        labels: {
          toolLabel: 'Guided Reading'
        }
      }
    ],
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: true,
    isContentType: true
  },
  {
    id: 'smartworksheet',
    value: 'smartworksheet',
    facet: 'Smart Worksheet',
    labels: {
      toolLabel: 'Smart Worksheet'
    },
    toolIcon: 'document',
    isIntegrationHubLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'staticfile',
    value: 'staticfile',
    facet: 'File',
    labels: {
      toolLabel: 'File'
    },
    toolIcon: 'document',
    isLocalToolLaunch: false,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: true,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'url',
    value: 'url',
    facet: 'url',
    labels: {
      toolLabel: 'Link'
    },
    toolIcon: 'link',
    isLocalToolLaunch: false,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'mapi',
    value: 'mapi',
    facet: 'Interactive',
    labels: {
      toolLabel: 'Interactive',
      searchResultLabel: 'Interactive'
    },
    toolIcon: 'interactive',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'instructorfile',
    value: 'instructorfile',
    facet: 'instructorfile',
    labels: {
      toolLabel: 'File'
    },
    toolIcon: 'document',
    isLocalToolLaunch: false,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'activelearning',
    value: 'altp',
    facet: 'In-Class Activity',
    labels: {
      toolLabel: 'In-Class Activity Guide',
      searchResultLabel: 'In-Class Activity'
    },
    toolIcon: 'in_class',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'writing',
    value: 'writing',
    facet: 'Writing',
    labels: {
      toolLabel: 'Writing Assignment',
      searchResultLabel: 'Writing Assignment'
    },
    toolIcon: 'multi_drafts',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: true,
    isContentType: true,
    subtypes: [
      {
        id: 'draft',
        labels: {
          toolLabel: 'Writing Assignment',
          subtypeLabel: 'Draft'
        }
      },
      {
        id: 'peer',
        labels: {
          toolLabel: 'Writing Assignment',
          subtypeLabel: 'Peer Review'
        }
      }
    ]
  },
  {
    id: 'writingassets',
    value: 'writingAssets',
    facet: 'writingassets',
    labels: {
      toolLabel: 'Adaptive Quiz'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'support',
    value: 'support',
    facet: 'Support',
    labels: {
      toolLabel: 'Help',
      searchResultLabel: 'Help'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'iclicker',
    value: 'iclicker',
    facet: 'iclicker',
    labels: {
      toolLabel: 'iClicker'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'reef',
    value: 'reef',
    facet: 'reef',
    labels: {
      toolLabel: 'iClicker'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'manual',
    value: 'manual',
    facet: 'manual',
    labels: {
      toolLabel: 'Manual Assignment'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  },
  {
    id: 'goreact',
    value: 'goreact',
    facet: 'GoReact',
    labels: {
      toolLabel: 'GoReact Video Assignment'
    },
    toolIcon: 'goreact',
    isIntegrationHubLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: true,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true
  },
  {
    id: 'ccw-pages',
    value: 'ccw-pages',
    facet: 'ccw-pages',
    labels: {
      toolLabel: 'Instructor Page',
      placeholderNameModal: 'Instructor Page'
    },
    toolIcon: 'document',
    isLocalToolLaunch: false,
    isIntegrationHubLaunch: true,
    isRenameable: true,
    isProductionToolTab: true,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: true,
    showInitialNameModal: true
  },
  {
    id: 'Unknown',
    value: 'Unknown',
    facet: 'Unknown',
    labels: {
      toolLabel: 'Unknown'
    },
    toolIcon: 'adaptive_quiz',
    isLocalToolLaunch: true,
    isRenameable: true,
    isProductionToolTab: false,
    allowDuplication: false,
    allowFacets: false,
    allowTimeContent: false,
    isContentType: false
  }
];

export default tools;
